var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "popup d-flex justify-content-center align-items-center",
      class: { "popup--visible": _vm.is_open },
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row d-flex justify-content-center" }, [
          _c(
            "div",
            { staticClass: "col-12 col-md-10 col-lg-8 popup__container" },
            [
              _c(
                "a",
                {
                  staticClass: "popup__close",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.closePopup.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "popup__close__ico",
                      attrs: {
                        width: "16px",
                        height: "16px",
                        viewBox: "0 0 16 16",
                        version: "1.1",
                        xmlns: "http://www.w3.org/2000/svg",
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      },
                    },
                    [
                      _c("title", [
                        _vm._v("7761595A-79BC-4696-9D3B-F79F423E42FD"),
                      ]),
                      _vm._v(" "),
                      _c("desc", [_vm._v("Created with sketchtool.")]),
                      _vm._v(" "),
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "desktop_design",
                            stroke: "none",
                            "stroke-width": "1",
                            fill: "none",
                            "fill-rule": "evenodd",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "cart",
                                transform: "translate(-512.000000, -28.000000)",
                                stroke: "#93999C",
                                "stroke-width": "1.4",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "icon/closeGrey",
                                    transform:
                                      "translate(513.000000, 29.000000)",
                                  },
                                },
                                [
                                  _c("line", {
                                    attrs: {
                                      x1: "14",
                                      y1: "0",
                                      x2: "0",
                                      y2: "14",
                                      id: "Stroke-429",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("line", {
                                    attrs: {
                                      x1: "14",
                                      y1: "14",
                                      x2: "0",
                                      y2: "0",
                                      id: "Stroke-430",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "text-center" }, [
                _c(
                  "h3",
                  {
                    staticClass:
                      "popup__title font__family--gotham font__weight--medium font__color--gray",
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.getTitle) +
                        "\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.getProductData
                  ? _c("div", { staticClass: "gif-product mb-5" }, [
                      _c("img", {
                        staticClass: "gif-product__image",
                        attrs: {
                          src: _vm.getProductData.image,
                          alt: "product image",
                        },
                      }),
                      _vm._v(" "),
                      _vm.getProductData.title
                        ? _c(
                            "h6",
                            {
                              staticClass:
                                "heading__h4 font__family--gotham font__weight--medium font__color--gray mb-0",
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.getProductData.title) +
                                  "\n                        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.getProductData.price
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "gif-product__price heading__h5 font__family--gotham font__weight--medium font__color--gray mb-0",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.getProductData.price) +
                                  " " +
                                  _vm._s(_vm.getProductData.currency)
                              ),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass:
                      "button button__size-1 button__font--size-1 text-white button__new button__new--blue",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.addGiftProductToCart.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "font__family--gotham font__weight--medium font__color--white",
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("add_product", "checkout")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass:
                      "button button__size-1 button__font--size-1 text-white button__new button__new--blue",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.closePopup.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "font__family--gotham font__weight--medium font__color--white",
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("cancel", "checkout")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }